import { lazy } from "react";
import Login from "../Pages/Login";
import EmailCodeLogin from "../Pages/EmailCodeLogin";
import SignUp from "../Pages/Signup";
import EmailCodeSignUp from "../Pages/EmailCodeSignUp";
import Dashboard from "../Pages/Dashboard";
import PageNotFound from "../Pages/PageNotFound";
import Ebilling from "../Pages/Ebilling";
import ConfirmUser from "../Pages/ConfirmUser";
import ResetPassword from "../Pages/ResetPassword";
import Settings from "../Pages/Settings";
import EbillingCreate from "../Pages/EbillingCreate";
import Consultation from "../Pages/Consultation";
import ConsultationForm from "../Pages/ConsultationForm";
import Checkout from "../Pages/Checkout";
import Subscription from "../Pages/Subscription";
import MySubscriptions from "../Pages/MySubscriptions";
import TransactionList from "../Pages/TransactionList";
import TransactionDetail from "../Pages/TransactionDetail";
import PaymentRedirect from "../Pages/PaymentRedirect";
import { Notification } from "../Pages/Notification";
import { EbillingDetail } from "../Pages/EbillingDetail";
import { CashBook } from "../Pages/CashBook";
import { CashBookCreate } from "../Pages/CashBookCreate";
import { Business } from "../Pages/Business";
import { BusinessCreate } from "../Pages/BusinessCreate";
import { BusinessDetail } from "../Pages/BusinessDetail";
import { CashBookDetail } from "../Pages/CashBookDetail";
import { AccountingTransactionList } from "../Pages/AccountingTransaction";
import { AccountingTransactionCreate } from "../Pages/AccountingTransactionCreate";
import { Verify } from "../Pages/Verify";
import CertificateVerify from "../Pages/CertificateVerify";
import NPWP from "../Pages/NPWPServiceList";
import NPWPValidate from "../Pages/NPWPValidate";
import { legacyReportRedirect } from "../Components/LegacyReportRedirect";
import EmeteraiHistory from "../Pages/EmeteraiHistory";
import { NPWPCreate } from "../Pages/NPWPCreate";
import { NPWPPreregister } from "../Pages/NPWPPreregister";
import { ConsultantList } from "../Pages/ConsultantList";
import { ConsultantDetail } from "../Pages/ConsultantDetail";
import { ConsultanTransactionList } from "../Pages/ConsultanTransactionList";
import { ConsultantWithdraw } from "../Pages/ConsultantWithdraw";
import { EbillingTemplate } from "../Pages/EbillingTemplate";
import { EmeteraiDetail } from "../Pages/EmeteraiDetail";
import CashBookImport from "../Pages/CashbookImport";
import { Account } from "../Pages/Account";
import { AccountCreate } from "../Pages/AccountCreate";
import { Partner } from "../Pages/Partner";
import { PartnerCreate } from "../Pages/PartnerCreate";
import AccountImport from "../Pages/AccountImport";
import WebinarList from "../Pages/WebinarList";
import ConsultantTutoringList from "../Pages/ConsultantTutoringList";
import ConsultantMenu from "../Pages/ConsultantMenu";
import TaxLearningList from "../Pages/TaxLearningList";
import TutoringList from "../Pages/TutoringList";
import BusinessInvitationList from "../Pages/BusinessInvitationList";
import BusinessInvitationCreate from "../Pages/BusinessInvitationCreate";
import PartnerTransactionList from "../Pages/PartnerTransactionList";
import { ProductList } from "../Pages/ProductList";
import { ProductCreate } from "../Pages/ProductCreate";
import { TaxList } from "../Pages/TaxList";
import { TaxCreate } from "../Pages/TaxCreate";
import InvoiceCreate from "../Pages/InvoiceCreate";
import InvoiceDetail from "../Pages/InvoiceDetail";
import ResourceList from "../Pages/ResourceList";
import { OpeningBalance } from "../Pages/OpeningBalance";
import { RewardPoints } from "../Pages/RewardPoints";
import OnboardingCOA from "../Pages/OnboardingCOA";
import AccountingTransactionImport from "../Pages/AccountingTransactionImport";
import EbillingSchedule from "../Pages/EbillingSchedule";
import EbillingScheduleCreate from "../Pages/EbillingScheduleCreate";
import EbillingScheduleDetail from "../Pages/EbillingScheduleDetail";
import Unsubscribe from "../Pages/Unsubscribe";
import BusinessLicenseList from "../Pages/BusinessLicenseList";
import BusinessLicenseDetail from "../Pages/BusinessLicenseDetail";
import { BusinessServiceForm } from "../Pages/BusinessServiceForm";
import BusinessServiceOrder from "../Pages/BusinessServiceOrder";
import { BusinessServiceOrderDetail } from "../Pages/BusinessServiceOrderDetail";
import ManageBusinessServiceList from "../Pages/ManageBusinessServiceList";
import ManageServiceDetailList from "../Pages/ManageServiceDetailList";
import ManageBusinessServiceDetail from "../Pages/ManageBusinessServiceDetail";
import BusinessServiceList from "../Pages/BusinessServiceList";
import BusinessServiceAddon from "../Pages/BusinessServiceAddon";
import BusinessServiceAddonCreate from "../Pages/BusinessServiceAddonCreate";
import Voucher from "../Pages/Voucher";
import ConsultationFormGuest from "../Pages/ConsultationFormGuest";
import ConsultationFormEmbed from "../Pages/ConsultationFormEmbed";
import ConsultationFormEmbedRedirect from "../Pages/ConsultationFormEmbedRedirect";
import AccountingTransactionImportDraft from "../Pages/AccountingTransactionImportDraft";
import AccountingTransactionImportDraftList from "../Pages/AccountingTransactionImportDraftList";
import { AccountTransactionList } from "../Pages/AccountTransaction";
import EbillingInputCodeForm from "../Pages/EbillingInputCodeForm";
import RewardProductDetail from "../Pages/RewardProductDetail";
import RewardProductList from "../Pages/RewardProductList";
import RewardRedemptionDetail from "../Pages/RewardRedemptionDetail";
import RewardRedemptionForm from "../Pages/RewardRedemptionForm";
import RewardRedemptionHistory from "../Pages/RewardRedemptionHistory";
import RedirectConsultation from "../Pages/RedirectConsultation";
import EmployeeCreate from "../Pages/EmployeeCreate";

// v2
import Accounting from "../Pages/v2/Accounting/Dashboard";
import AccountingCashFlow from "../Pages/v2/Accounting/CashFlow";
import ProductsServices from "../Pages/v2/Accounting/ProductsServices";
import ProductStockHistory from "../Pages/v2/Accounting/ProductStockHistory";
import ProductCategories from "../Pages/v2/Accounting/ProductCategories";
import Contacts from "../Pages/v2/Accounting/Contacts";
import AccountingTaxes from "../Pages/v2/Accounting/Taxes";
import AccountingFixedAssets from "../Pages/v2/Accounting/FixedAssets";
import ChartOfAccounts from "../Pages/v2/Accounting/ChartOfAccounts";
import OpeningBalanceV2 from "../Pages/v2/Accounting/OpeningBalance";
import PeriodCloseV2 from "../Pages/v2/Accounting/PeriodClose";
import PeriodClose from "../Pages/PeriodClose";
import AccountingExpenses from "../Pages/v2/Accounting/Expenses";
import AccountingIncomes from "../Pages/v2/Accounting/Incomes";
import AccountingReports from "../Pages/v2/Accounting/Reports";
import AccountingSummaryV2 from "../Pages/v2/Accounting/Reports/Summary";
import AccountingTransactions from "../Pages/v2/Accounting/Transactions";
import Employees from "../Pages/v2/Accounting/Employees";
import SalaryTable from "../Pages/SalaryTable";
import EmployeeAttendances from "../Pages/EmployeeAttendances";
import EmployeeAttendancesV2 from "../Pages/v2/Accounting/Attendances";
import Calendars from "../Pages/v2/Accounting/Calendars";
import AccountingPayroll from "../Pages/v2/Accounting/Payroll";
import AccountingPayrollOpeningBalance from "../Pages/v2/Accounting/PayrollOpeningBalance";
import CashBookV2 from "../Pages/v2/Cashbook/Dashboard";
import AccountingGeneralJournal from "../Pages/v2/Accounting/GeneralJournal";
import AccountingBalanceSheet from "../Pages/v2/Accounting/BalanceSheet";
import AccountingTrialBalance from "../Pages/v2/Accounting/TrialBalance";
import AccountingIncomeStatement from "../Pages/v2/Accounting/IncomeStatement";
import AccountingCapitalStatement from "../Pages/v2/Accounting/CapitalStatement";
import AccountingCashFlowReport from "../Pages/v2/Accounting/CashFlowReport";
import AccountingVatRecap from "../Pages/v2/Accounting/Reports/VatRecap";
import AccountingAging from "../Pages/v2/Accounting/Reports/Partner/Aging";
import AccountingPartnerLedger from "../Pages/v2/Accounting/Reports/Partner/PartnerLedger";

// tax calculator
import TaxCalculator from "../Pages/TaxCalculator";
import CalculatorPph2126 from "../Pages/Calculator/CalculatorPph2126";
import CalculatorPph23 from "../Pages/Calculator/CalculatorPph23";
import CalculatorPphFinal42 from "../Pages/Calculator/CalculatorPphFinal42";

const Emeterai = lazy(() => import("../Pages/Emeterai"));
const WebinarDetail = lazy(() => import("../Pages/WebinarDetail"));
const Chat = lazy(() => import("../Pages/Chat"));
const ChatV2 = lazy(() => import("../Pages/v2/Chat"));
const ChatV3 = lazy(() => import("../Pages/v3/Chat"));
const ChatResolver = lazy(() => import("../Pages/ChatResolver"));
const ChatEmbed = lazy(() => import("../Pages/ChatEmbed"));
const TutoringDetail = lazy(() => import("../Pages/TutoringDetail"));
const ConsultantTutoringCreate = lazy(
  () => import("../Pages/ConsultantTutoringCreate"),
);
const DocumentViewer = lazy(() => import("../Pages/DocumentViewer"));
const AccountingTransactionImportEmbed = lazy(
  () => import("../Pages/AccountingTransactionImportEmbed"),
);
const AccountingTransactionsEmbed = lazy(
  () => import("../Pages/AccountingTransactionsEmbed"),
);
const AccountingReportsEmbed = lazy(
  () => import("../Pages/AccountingReportsEmbed"),
);
const AccountingGeneralJournalEmbed = lazy(
  () => import("../Pages/AccountingGeneralJournalEmbed"),
);
const AccountingBalanceSheetEmbed = lazy(
  () => import("../Pages/AccountingBalanceSheetEmbed"),
);
const AccountingTrialBalanceEmbed = lazy(
  () => import("../Pages/AccountingTrialBalanceEmbed"),
);
const AccountingIncomeStatementEmbed = lazy(
  () => import("../Pages/AccountingIncomeStatementEmbed"),
);
const AccountingCapitalStatementEmbed = lazy(
  () => import("../Pages/AccountingCapitalStatementEmbed"),
);
const AccountingCashFlowEmbed = lazy(
  () => import("../Pages/AccountingCashFlowEmbed"),
);

const routes = [
  {
    path: "/login",
    element: Login,
    protected: false,
    title: "Log in",
    hideTitle: true,
  },
  {
    path: "/passwordless-login",
    element: EmailCodeLogin,
    protected: false,
    title: "Log in using code",
    hideTitle: true,
  },
  {
    path: "/verify",
    element: Verify,
    protected: false,
    title: "Verifying account",
    hideTitle: true,
  },
  {
    path: "/verify/certificate",
    element: CertificateVerify,
    protected: true,
    title: "Certificate Verification",
    hideTitle: true,
  },
  {
    path: "/signup",
    element: SignUp,
    protected: false,
    title: "Sign up",
    hideTitle: true,
  },
  {
    path: "/passwordless-signup",
    element: EmailCodeSignUp,
    protected: false,
    title: "Register using code",
    hideTitle: true,
  },
  {
    path: "/confirm",
    element: ConfirmUser,
    protected: false,
    title: "Confirm your account",
    hideTitle: true,
  },
  {
    path: "/reset",
    element: ResetPassword,
    protected: false,
    title: "Reset password",
    hideTitle: true,
  },
  {
    path: "/dashboard",
    element: Dashboard,
    title: "Dashboard",
    hideTitle: true,
    breadcrumbs: [
      {
        title: "Dashboard",
        path: "/dashboard",
      },
    ],
    protected: true,
  },
  {
    path: "/settings",
    element: Settings,
    title: "Settings",
    protected: true,
  },
  {
    path: "/settings/:id",
    element: Settings,
    title: "Settings",
    protected: true,
  },
  {
    path: "/ebilling",
    element: Ebilling,
    title: "E-Billing",
    protected: true,
  },
  {
    path: "/ebilling/template",
    element: EbillingTemplate,
    title: "Create E-Billing",
    protected: true,
  },
  {
    path: "/ebilling/create",
    element: EbillingCreate,
    title: "Create E-Billing",
    protected: true,
  },
  {
    path: "/ebilling/:id",
    element: EbillingDetail,
    title: "E-Billing Detail",
    protected: true,
  },
  {
    path: "/consultation",
    element: Consultation,
    title: "Consultation",
    protected: true,
  },
  {
    // Dynamic resolver: fetches videoProvider, redirects to /chat | /v2/chat | /v3/chat.
    // Also the FCM web-push deep-link target.
    path: "/consultation/:id",
    element: ChatResolver,
    title: "Consultation",
    protected: true,
  },
  {
    // v1 chat (OpenTok/tokbox + plain chat) — default video provider.
    path: "/chat/:id",
    element: Chat,
    title: "Consultation",
    protected: true,
  },
  {
    path: "/consultation/redirect/:id",
    element: RedirectConsultation,
    title: "Consultation Request",
    protected: true,
    hideTitle: true,
  },
  {
    path: "/consultation/form",
    element: ConsultationForm,
    title: "Consultation Form",
    protected: true,
  },
  {
    path: "/consultation/form/:id",
    element: ConsultationForm,
    title: "Consultation Form",
    protected: true,
  },
  {
    path: "/checkout",
    element: Checkout,
    title: "Checkout",
    protected: true,
  },
  {
    path: "/transaction",
    element: TransactionList,
    title: "Transaction List",
    protected: true,
  },
  {
    path: "/notification",
    element: Notification,
    title: "Notification",
    protected: true,
  },
  {
    path: "/transaction/redirect",
    element: PaymentRedirect,
    protected: true,
    title: "Payment Status",
    hideTitle: true,
  },
  {
    path: "/transaction/:id",
    element: TransactionDetail,
    title: "Transaction Detail",
    breadcrumbs: [
      {
        title: "Transaction List",
        path: "/transaction",
      },
      {
        title: "Transaction Detail",
        path: "/transaction",
      },
    ],
    protected: true,
  },
  {
    path: "/subscription",
    element: Subscription,
    title: "Subscription Plan",
    protected: true,
  },
  {
    path: "/my-subscriptions",
    element: MySubscriptions,
    title: "mySubscriptions",
    protected: true,
  },
  {
    path: "/npwp-services",
    element: NPWP,
    title: "NPWP Services",
    protected: true,
  },
  {
    path: "/npwp-validation",
    element: NPWPValidate,
    title: "NPWP Validation",
    protected: true,
  },
  {
    path: "/npwp-create",
    element: NPWPCreate,
    title: "NPWP Creation",
    protected: true,
  },
  {
    path: "/npwp-preregister",
    element: NPWPPreregister,
    title: "NPWP Registration",
    protected: true,
  },
  {
    path: "/*",
    element: PageNotFound,
    title: "Not Found",
    protected: false,
  },
  {
    path: "/cash-book",
    element: CashBook,
    title: "Cash Book",
    protected: true,
  },
  {
    path: "/cash-book/:id",
    element: CashBookDetail,
    title: "Cash Book Detail",
    protected: true,
  },
  {
    path: "/cash-book/create",
    element: CashBookCreate,
    title: "Create Cash Book Transaction",
    protected: true,
  },
  {
    path: "/cash-book/import",
    element: CashBookImport,
    title: "Cash Book Transaction Import",
    protected: true,
  },
  {
    path: "/business",
    element: Business,
    title: "Business List",
    protected: true,
  },
  {
    path: "/business/create",
    element: BusinessCreate,
    title: "Create New Business",
    protected: true,
  },
  {
    path: "/business/:id",
    element: BusinessDetail,
    title: "Business Detail",
    protected: true,
  },
  {
    path: "/accounting",
    element: AccountingTransactionList,
    title: "Accounting",
    protected: true,
  },
  {
    path: "/accounting-transaction/create",
    element: AccountingTransactionCreate,
    title: "Accounting Transaction",
    protected: true,
  },
  // The old report pages are gone; their bookmarks land on the v2 reports.
  {
    path: "/accounting-report/general-journal",
    element: legacyReportRedirect("/v2/accounting/reports/general-journal"),
    protected: true,
  },
  {
    path: "/accounting-report/trial-balance",
    element: legacyReportRedirect("/v2/accounting/reports/trial-balance"),
    protected: true,
  },
  {
    path: "/accounting-report/income-statement",
    element: legacyReportRedirect("/v2/accounting/reports/income-statement"),
    protected: true,
  },
  {
    path: "/accounting-report/capital-statement",
    element: legacyReportRedirect("/v2/accounting/reports/capital-statement"),
    protected: true,
  },
  {
    path: "/accounting-report/cash-flow",
    element: legacyReportRedirect("/v2/accounting/reports/cash-flow"),
    protected: true,
  },
  {
    path: "/accounting-report/balance-sheet",
    element: legacyReportRedirect("/v2/accounting/reports/balance-sheet"),
    protected: true,
  },
  {
    path: "/accounting-report/accounting-summary",
    element: legacyReportRedirect("/v2/accounting/reports/summary"),
    protected: true,
  },
  {
    path: "/consultant",
    element: ConsultantList,
    title: "Consultant",
    protected: true,
  },
  {
    path: "/consultant/:id",
    element: ConsultantDetail,
    title: "consultant.page.title",
    protected: true,
  },
  {
    path: "/manage-consultation",
    element: ConsultantMenu,
    title: "Manage Consultation",
    protected: true,
  },
  {
    path: "/manage-tutoring",
    element: ConsultantTutoringList,
    title: "Manage Tutoring Program",
    protected: true,
  },
  {
    path: "/manage-tutoring/create",
    element: ConsultantTutoringCreate,
    title: "Create Tutoring Program",
    protected: true,
  },
  {
    path: "/manage-tutoring/edit/:id",
    element: ConsultantTutoringCreate,
    title: "Edit Tutoring Program",
    protected: true,
  },
  {
    path: "/consultant-transaction",
    element: ConsultanTransactionList,
    title: "List of Consultant Transactions",
    protected: true,
  },
  {
    path: "/consultant-withdraw",
    element: ConsultantWithdraw,
    title: "Withdraw Balance",
    protected: true,
  },
  {
    path: "/emeterai",
    element: Emeterai,
    title: "E-Meterai",
    protected: true,
  },
  {
    path: "/emeterai/detail/:id",
    element: EmeteraiDetail,
    title: "E-Meterai Detail",
    protected: true,
  },
  {
    path: "/emeterai/history",
    element: EmeteraiHistory,
    title: "E-Meterai Stamping History",
    protected: true,
  },
  {
    path: "/account",
    element: Account,
    title: "Accounting Account",
    protected: true,
  },
  {
    path: "/account/create",
    element: AccountCreate,
    title: "Create Accounting Account",
    protected: true,
  },
  {
    path: "/account/import",
    element: AccountImport,
    title: "Import Accounting Accounts",
    protected: true,
  },
  {
    path: "/account/transaction",
    element: AccountTransactionList,
    title: "accountTransaction",
    protected: true,
  },
  {
    path: "/partner",
    element: Partner,
    title: "Partners & Customers",
    protected: true,
  },
  {
    path: "/partner/create",
    element: PartnerCreate,
    title: "Create New Partner",
    protected: true,
  },
  {
    path: "/partner/:id",
    element: PartnerTransactionList,
    title: "Partner Transaction",
    protected: true,
  },
  {
    path: "/webinar",
    element: WebinarList,
    title: "Webinar",
    protected: true,
  },
  {
    path: "/webinar/:id",
    element: WebinarDetail,
    title: "Webinar Detail",
    protected: false,
  },
  {
    path: "/learn",
    element: TaxLearningList,
    title: "Tax Learning",
    protected: true,
  },
  {
    path: "/tutoring",
    element: TutoringList,
    title: "Tutoring Programs",
    protected: true,
  },
  {
    path: "/tutoring/detail/:id",
    element: TutoringDetail,
    title: "Tutoring Program Detail",
    protected: true,
  },
  {
    path: "/document",
    element: DocumentViewer,
    title: "Document Viewer",
    protected: true,
  },
  {
    path: "/business-invites",
    element: BusinessInvitationList,
    title: "Business Access Invitation List",
    protected: true,
  },
  {
    path: "/business-invites/create",
    element: BusinessInvitationCreate,
    title: "Business Access Invitation",
    protected: true,
  },
  {
    path: "/product",
    element: ProductList,
    title: "Product List",
    protected: true,
  },
  {
    path: "/product/create",
    element: ProductCreate,
    title: "Create New Product",
    protected: true,
  },
  {
    path: "/product/edit/:id",
    element: ProductCreate,
    title: "Change Product",
    protected: true,
  },
  {
    path: "/tax",
    element: TaxList,
    title: "Tax List",
    protected: true,
  },
  {
    path: "/tax/create",
    element: TaxCreate,
    title: "Create New Tax",
    protected: true,
  },
  {
    path: "/tax/edit/:id",
    element: TaxCreate,
    title: "Change Tax",
    protected: true,
  },
  {
    path: "/invoice/create",
    element: InvoiceCreate,
    title: "Invoice",
    protected: true,
  },
  {
    path: "/invoice/:id",
    element: InvoiceDetail,
    title: "Invoice Detail",
    protected: true,
  },
  {
    path: "/invoice/edit/:id",
    element: InvoiceCreate,
    title: "Edit Invoice",
    protected: true,
  },
  {
    path: "/purchase/create",
    element: InvoiceCreate,
    title: "Purchase Invoice",
    protected: true,
  },
  {
    path: "/purchase/edit/:id",
    element: InvoiceCreate,
    title: "Edit Purchase Invoice",
    protected: true,
  },
  {
    path: "/resource",
    element: ResourceList,
    title: "Tax Materials",
    protected: true,
  },
  {
    path: "/opening-balance",
    element: OpeningBalance,
    title: "Opening Balance",
    protected: true,
  },
  {
    path: "/period-close",
    element: PeriodClose,
    title: "accounting.period.label",
    protected: true,
  },
  {
    path: "/points",
    element: RewardPoints,
    title: "rewardPoints",
    protected: true,
  },
  {
    path: "/coa-onboarding/:id",
    element: OnboardingCOA,
    title: "Chart of Accounts (COA)",
    protected: true,
  },
  {
    path: "/accounting-transaction/import",
    element: AccountingTransactionImport,
    title: "transactionAccImportTitle",
    protected: true,
  },
  {
    path: "/scheduled-ebilling",
    element: EbillingSchedule,
    title: "scheduledEbillingTitle",
    protected: true,
  },
  {
    path: "/scheduled-ebilling/create",
    element: EbillingScheduleCreate,
    title: "createScheduleTitle",
    protected: true,
  },
  {
    path: "/scheduled-ebilling/:id",
    element: EbillingScheduleCreate,
    title: "editScheduleTitle",
    protected: true,
  },
  {
    path: "/scheduled-ebilling/detail/:id",
    element: EbillingScheduleDetail,
    title: "detailScheduleTitle",
    protected: true,
  },
  {
    path: "/newsletter/unsubscribe",
    element: Unsubscribe,
  },
  {
    path: "/business-license",
    element: BusinessLicenseList,
    title: "businessLicenseTitle",
    protected: true,
  },
  {
    path: "/business-service/:id",
    element: BusinessLicenseDetail,
    protected: true,
  },
  {
    path: "/business-service/form/:id",
    element: BusinessServiceForm,
    title: "businessServiceFormTitle",
    protected: true,
  },
  {
    path: "/business-service/order",
    element: BusinessServiceOrder,
    title: "businessServiceOrderTitle",
    protected: true,
  },
  {
    path: "/business-service/order/:id",
    element: BusinessServiceOrderDetail,
    title: "businessServiceOrderDetailTitle",
    protected: true,
  },
  {
    path: "/manage-business-service",
    element: ManageBusinessServiceList,
    title: "manageBusinessServiceListTitle",
    protected: true,
  },
  {
    path: "/manage-business-service/:id",
    element: ManageServiceDetailList,
    protected: true,
  },
  {
    path: "/manage-business-service/edit/:id",
    element: ManageBusinessServiceDetail,
    title: "manageBusinessServiceDetailTitle",
    protected: true,
  },
  {
    path: "/manage-business-service/create",
    element: ManageBusinessServiceDetail,
    title: "createBusinessService",
    protected: true,
  },
  {
    path: "/business-service",
    element: BusinessServiceList,
    title: "businessServiceTitle",
    protected: true,
  },
  {
    path: "/manage-business-service/addons",
    element: BusinessServiceAddon,
    title: "businessServiceAddonTitle",
    protected: true,
  },
  {
    path: "/manage-business-service/addons/create",
    element: BusinessServiceAddonCreate,
    title: "businessServiceAddonCreateTitle",
    protected: true,
  },
  {
    path: "/voucher",
    element: Voucher,
    title: "voucherTitle",
    protected: true,
  },
  {
    path: "/guest/consultation/form",
    element: ConsultationFormGuest,
    title: "Consultation Form",
    protected: false,
  },
  {
    path: "/embed/consultation/form",
    element: ConsultationFormEmbed,
    title: "Consultation Form",
    protected: false,
    embed: true,
  },
  {
    path: "/embed/consultation/redirect/:id",
    element: ConsultationFormEmbedRedirect,
    title: "Consultation Request",
    protected: false,
    embed: true,
  },
  {
    path: "/embed/consultation/:id",
    element: ChatEmbed,
    title: "Consultation",
    protected: true,
    embed: true,
  },
  {
    path: "/embed/accounting-transaction/import",
    element: AccountingTransactionImportEmbed,
    title: "transactionAccImportTitle",
    protected: false,
    embed: true,
  },
  {
    path: "/embed/accounting/transactions",
    element: AccountingTransactionsEmbed,
    title: "accounting.transactions.title",
    protected: true,
    embed: true,
  },
  {
    path: "/embed/accounting/reports",
    element: AccountingReportsEmbed,
    title: "accounting.reports.title",
    protected: true,
    embed: true,
  },
  {
    path: "/embed/accounting/reports/general-journal",
    element: AccountingGeneralJournalEmbed,
    title: "accounting.reports.generalJournal",
    protected: true,
    embed: true,
  },
  {
    path: "/embed/accounting/reports/balance-sheet",
    element: AccountingBalanceSheetEmbed,
    title: "accounting.reports.balanceSheet",
    protected: true,
    embed: true,
  },
  {
    path: "/embed/accounting/reports/trial-balance",
    element: AccountingTrialBalanceEmbed,
    title: "accounting.reports.trialBalance",
    protected: true,
    embed: true,
  },
  {
    path: "/embed/accounting/reports/income-statement",
    element: AccountingIncomeStatementEmbed,
    title: "accounting.reports.incomeStatement",
    protected: true,
    embed: true,
  },
  {
    path: "/embed/accounting/reports/capital-statement",
    element: AccountingCapitalStatementEmbed,
    title: "accounting.reports.capitalStatement",
    protected: true,
    embed: true,
  },
  {
    path: "/embed/accounting/reports/cash-flow",
    element: AccountingCashFlowEmbed,
    title: "accounting.reports.cashFlow",
    protected: true,
    embed: true,
  },
  {
    path: "/accounting-transaction/draft/:id",
    element: AccountingTransactionImportDraft,
    title: "draftImportDetailTitle",
    protected: true,
  },
  {
    path: "/accounting-transaction/draft",
    element: AccountingTransactionImportDraftList,
    title: "draftImportTitle",
    protected: true,
  },
  // v2
  {
    path: "/v2/chat/:id",
    element: ChatV2,
    title: "Consultation",
    protected: true,
  },
  // v3 (RealtimeKit)
  {
    path: "/v3/chat/:id",
    element: ChatV3,
    title: "Consultation",
    protected: true,
  },
  {
    path: "/v2/accounting",
    element: Accounting,
    title: "Accounting",
    protected: true,
  },
  {
    path: "/v2/accounting/cashflow",
    element: AccountingCashFlow,
    title: "Cash Flow",
    protected: true,
  },
  {
    path: "/v2/accounting/products",
    element: ProductsServices,
    title: "products.label",
    protected: true,
  },
  {
    path: "/v2/accounting/products/stock-history/:productId",
    element: ProductStockHistory,
    title: "products.stockHistory.label",
    protected: true,
  },
  {
    path: "/v2/accounting/product-categories",
    element: ProductCategories,
    title: "products.categories.label",
    protected: true,
  },
  {
    path: "/v2/accounting/contacts",
    element: Contacts,
    title: "contacts.label",
    protected: true,
  },
  {
    path: "/v2/accounting/taxes",
    element: AccountingTaxes,
    title: "Taxes",
    protected: true,
  },
  {
    path: "/v2/accounting/fixed-assets",
    element: AccountingFixedAssets,
    title: "fixedAssets.label",
    protected: true,
  },
  {
    path: "/v2/accounting/coa",
    element: ChartOfAccounts,
    title: "accounting.coa",
    protected: true,
  },
  {
    path: "/v2/accounting/coa/opening-balance",
    element: OpeningBalanceV2,
    title: "accounting.openingBalance",
    protected: true,
  },
  {
    path: "/v2/accounting/period",
    element: PeriodCloseV2,
    title: "accounting.period.label",
    protected: true,
  },
  {
    path: "/v2/accounting/expenses",
    element: AccountingExpenses,
    title: "accounting.expenses.label",
    protected: true,
  },
  {
    path: "/v2/accounting/incomes",
    element: AccountingIncomes,
    title: "Income",
    protected: true,
  },
  {
    path: "/v2/accounting/reports",
    element: AccountingReports,
    title: "accounting.reports.label",
    protected: true,
  },
  {
    path: "/v2/accounting/reports/summary",
    element: AccountingSummaryV2,
    title: "accounting.summary.title",
    protected: true,
  },
  {
    path: "/v2/accounting/transactions",
    element: AccountingTransactions,
    title: "accounting.transactions.title",
    protected: true,
  },
  {
    path: "/v2/accounting/reports/general-journal",
    element: AccountingGeneralJournal,
    title: "General Journal",
    protected: true,
  },
  {
    path: "/v2/accounting/reports/balance-sheet",
    element: AccountingBalanceSheet,
    title: "Balance Sheet",
    protected: true,
  },
  {
    path: "/v2/accounting/reports/trial-balance",
    element: AccountingTrialBalance,
    title: "Trial Balance",
    protected: true,
  },
  {
    path: "/v2/accounting/reports/income-statement",
    element: AccountingIncomeStatement,
    title: "Income Statement",
    protected: true,
  },
  {
    path: "/v2/accounting/reports/capital-statement",
    element: AccountingCapitalStatement,
    title: "Capital Statement",
    protected: true,
  },
  {
    path: "/v2/accounting/reports/cash-flow",
    element: AccountingCashFlowReport,
    title: "Cash Flow",
    protected: true,
  },
  {
    path: "/v2/accounting/reports/vat-recap",
    element: AccountingVatRecap,
    title: "reports.vatRecap.name",
    protected: true,
  },
  {
    path: "/v2/accounting/reports/aging",
    element: AccountingAging,
    title: "reports.aging.name",
    protected: true,
  },
  {
    path: "/v2/accounting/reports/partner-ledger",
    element: AccountingPartnerLedger,
    title: "reports.partnerLedger.name",
    protected: true,
  },
  {
    path: "/v2/accounting/employees",
    element: Employees,
    title: "employees.label",
    protected: true,
  },
  {
    path: "/v2/accounting/employees/attendance",
    element: EmployeeAttendancesV2,
    title: "employees.attendances.title",
    protected: true,
  },
  {
    path: "/v2/accounting/employees/attendance/:id",
    element: EmployeeAttendancesV2,
    title: "employees.attendances.title",
    protected: true,
  },
  {
    path: "/v2/accounting/calendars",
    element: Calendars,
    title: "employees.calendars.label",
    protected: true,
  },
  {
    path: "/v2/accounting/payroll",
    element: AccountingPayroll,
    title: "payroll.title",
    protected: true,
  },
  {
    path: "/v2/accounting/payroll/opening-balance",
    element: AccountingPayrollOpeningBalance,
    title: "payroll.openingBalance.title",
    protected: true,
  },
  {
    path: "/employee/create",
    element: EmployeeCreate,
    title: "employees.label",
    protected: true,
  },
  {
    path: "/ebilling/input",
    element: EbillingInputCodeForm,
    title: "inputCodeBillingLabel",
    protected: true,
  },
  {
    path: "/rewards-product/:id",
    element: RewardProductDetail,
    title: "rewardProductDetailTitle",
    protected: true,
  },
  {
    path: "/rewards-product",
    element: RewardProductList,
    title: "rewardProductTitle",
    protected: true,
  },
  {
    path: "reward-redemption/:id",
    element: RewardRedemptionForm,
    title: "rewardProductCheckout",
    protected: true,
  },
  {
    path: "rewards-redemption/:id",
    element: RewardRedemptionDetail,
    title: "rewardRedemptionDetails",
    protected: true,
  },
  {
    path: "redemption-history",
    element: RewardRedemptionHistory,
    title: "pointRedemptionHistory",
    protected: true,
  },
  {
    path: "/employee/salary/:id",
    element: SalaryTable,
    title: "employees.salaries.label",
    protected: true,
  },
  {
    path: "/employee/attendance/:id",
    element: EmployeeAttendances,
    title: "employees.attendances.title",
    protected: true,
  },
  {
    path: "/v2/cash-book",
    element: CashBookV2,
    title: "Cash Book",
    protected: true,
  },
  {
    path: "/tax-calculator",
    element: TaxCalculator,
    title: "taxCalculator.title",
    protected: false,
  },
  {
    path: "/tax-calculator/pph-21-26",
    element: CalculatorPph2126,
    title: "taxCalculator.pph2126.title",
    protected: false,
  },
  {
    path: "/tax-calculator/pph-23",
    element: CalculatorPph23,
    title: "taxCalculator.pph23.title",
    protected: false,
  },
  {
    path: "/tax-calculator/pph-final-4-2",
    element: CalculatorPphFinal42,
    title: "taxCalculator.pphFinal42.title",
    protected: false,
  },
];

export default routes;
